export default __webpack_public_path__ + "static/real3-e298b80f880c5bce6d4ca3017cb85679.png";